import { MY_PRODUCTS_ROUTE } from '../constants/routePathConstants';
import { sidebarSelector } from '../redux/slicers/admin/sidebarSlicer';
import { sortBy } from 'lodash';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useGlobalFilters = () => {
  const location = useLocation();
  const { filtersData, filterValues } = useSelector(sidebarSelector);

  let filtersLoading = true;

  const filters = [];
  //   {
  //     items: [
  //       {
  //         label: 'My favorites',
  //         value: 'favourite',
  //       },
  //     ],
  //   },
  // ];

  // add api filters
  const apiFilters = useMemo(() => {
    if (!filtersData || !Object.keys(filtersData).length) {
      filtersLoading = false;
      return [];
    }
    if (location.pathname === MY_PRODUCTS_ROUTE) {
      filtersLoading = false;
      return [];
    }

    const sortedFilters = sortBy(filtersData?.filterlabels || [], ['order']);

    let result =
      sortedFilters.map((label) => {
        const labelName = label.label_name;
        return {
          title: label.label_name,
          items: filtersData.filteroptions
            .filter((item) => item.filter_label === label.id)
            .map((item) => ({
              label: item.name,
              value: `option_${item.filter_label}_${item.id}`,
            })),
          ...(filtersData?.otherDetails && `${labelName}_${label.id}` in filtersData?.otherDetails
            ? { ...filtersData?.otherDetails?.[`${labelName}_${label.id}`] }
            : {}),
        };
      }) || [];

    if (filtersData.props?.length) {
      const props = {
        title: 'My Products',
        items: filtersData.props.map((prop) => ({
          label: prop.name,
          value: `prop_${prop.id}`,
        })),
        ...filtersData?.otherDetails?.props,
      };

      result = [props, ...result];
    }

    if (filtersData.brands?.length) {
      const brands = {
        title: 'Brands',
        items: filtersData.brands.map((brand) => ({
          label: brand.name,
          value: `brand_${brand.id}`,
        })),
        ...filtersData?.otherDetails?.brands,
      };

      result = [brands, ...result];
    }

    if (filtersData.collections?.length) {
      const collections = {
        title: 'Collections',
        items: filtersData.collections.map((collection) => ({
          label: collection.name,
          value: `collection_${collection.id}`,
        })),
        ...filtersData?.otherDetails?.collections,
      };

      result = [collections, ...result];
    }

    filtersLoading = false;

    return result;
  }, [filtersData]);

  apiFilters.length ? filters.push(...apiFilters) : (filters.length = 0);

  return { filters, filterValues, filtersLoading };
};
